export default __webpack_public_path__ + "static/media/hero10.4de804a4.png";